import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import { SidebarDiv } from "./elements";
import { sortBy } from "./../Layout";

const Sidebar = () => {
  const sidebarQuery = useStaticQuery(graphql`
    query {
      allSanityPerson {
        nodes {
          _id
          title
          alphabetizeBy
        }
      }
      allSanityKeyword {
        nodes {
          title
          _id
        }
      }
      allSanityWalk {
        nodes {
          title
          _id
        }
      }
    }
  `);
  const { allSanityPerson, allSanityKeyword, allSanityWalk } = sidebarQuery;
  return (
    <SidebarDiv>
      <div>
        <h2>View all objects by:</h2>
        <ul>
          <li>
            <Link to="/">Cards</Link>
          </li>
          <li>
            <Link to="/timeline">Timeline</Link>
          </li>
        </ul>
        <hr />
        <div>
          <h2>People:</h2>
          <ul>
            {sortBy(allSanityPerson.nodes, "alphabetizeBy").map(
              (walk, index) => (
                <li key={index}>
                  <Link to={`/person/${walk._id}`}>{walk.title}</Link>
                </li>
              )
            )}
          </ul>
        </div>
        <div>
          <h2>Keywords:</h2>
          <ul>
            {sortBy(allSanityKeyword.nodes, "title").map((walk, index) => (
              <li key={index}>
                <Link to={`/keyword/${walk._id}`}>{walk.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2>Walks:</h2>
          <ul>
            {sortBy(allSanityWalk.nodes, "title").map((walk, index) => (
              <li key={index}>
                <Link to={`/walk/${walk._id}`}>{walk.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </SidebarDiv>
  );
};

export default Sidebar;
